import React, { Component, PropTypes } from 'react';
import debounce from 'pluton-core/lib/utils/debounce';

export default class InfiniteScroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            lastScrollTop: 0,
            actionTriggered: false
        };
        this.onScrollListener = this.onScrollListener.bind(this);
        this.debouncedOnScrollListener = this.onScrollListener; // debounce(this.onScrollListener, 50).bind(this);
    }

    componentDidMount() {
        this.el = this.refs.infScroll.parentNode;
        this.el.addEventListener('scroll', this.debouncedOnScrollListener);
    }

    componentWillUnmount() {
        this.el.removeEventListener('scroll', this.debouncedOnScrollListener);
    }

    componentWillReceiveProps(props) {
        // new data was sent in
        this.setState({
            showLoader: false,
            actionTriggered: false
        });
    }

    isElementAtBottom(target, scrollThreshold = 0.9) {
        const scrolled = scrollThreshold * (target.scrollHeight - target.scrollTop);
        const { clientHeight } = target;
        return scrolled < clientHeight;
    }

    isElementAtTop = (target) => {
        return target.scrollTop < this.state.lastScrollTop;
    };

    onScrollListener(event) {
        let target = this.el;
        let atTop = this.isElementAtTop(target);
        let atBottom = this.isElementAtBottom(target, this.props.scrollThreshold);
        this.props.onScroll && this.props.onScroll(event, atTop, atBottom);

        // if user scrolls up, remove action trigger lock
        if (atTop && !this.props.isLoading) {

            if (target.scrollTop <= this.props.prevFiredHeight && this.props.prev) {
                this.props.prev && this.props.prev();
                this.setState({ actionTriggered: true, showLoader: true });
                return;
            }

            this.setState({
                actionTriggered: false,
                lastScrollTop: target.scrollTop
            });

            return; // user's going up, we don't care
        }

        // return immediately if the action has already been triggered,
        // prevents multiple triggers.
        if (this.state.actionTriggered) {
            return;
        }

        // call the `next` function in the props to trigger the next data fetch
        if (atBottom && this.props.hasMore && !this.props.isLoading) {
            this.props.next && this.props.next();
            this.setState({ actionTriggered: true, showLoader: true });
        }
        this.setState({ lastScrollTop: target.scrollTop });
    }

    render() {
        const style = {
            height: this.props.height || 'auto',
            'overflowX': 'hidden',
            'overflowY': 'auto'
        };

        const hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children.length);

        return (
            <div className='infinite-scroll-component'
                 ref='infScroll'
                 style={style}>
                {this.props.children}
                {
                    !this.state.showLoader && !hasChildren &&
                    this.props.hasMore && this.props.loader
                }
                {this.state.showLoader && this.props.loader}
                {
                    !this.props.hasMore && (
                        <p style={{textAlign: 'center'}}>
                            {this.props.endMessage}
                        </p>
                    )
                }
            </div>
        );
    }
}

InfiniteScroll.defaultProps = {
    prevFiredHeight: 40
};

InfiniteScroll.propTypes = {
    next: PropTypes.func,
    prev: PropTypes.func,
    isLoading: PropTypes.bool,
    hasMore: PropTypes.bool,
    children: PropTypes.node,
    loader: PropTypes.node.isRequired,
    scrollThreshold: PropTypes.number,
    endMessage: PropTypes.node,
    style: PropTypes.object,
    height: PropTypes.number,
    hasChildren: PropTypes.bool,
    prevFiredHeight: PropTypes.number,
    onScroll: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/controls/infiniteScroll/index.js